var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7076",
  fillRule: "evenodd",
  d: "M7.48 8 4.8 5.32l.52-.52L8 7.48l2.68-2.68.52.52L8.52 8l2.68 2.68-.52.52L8 8.52 5.32 11.2l-.52-.52L7.48 8Z",
  clipRule: "evenodd"
})));
export { SvgIcClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQ4MDA2IDguMDAwMDVMNC43OTk4IDUuMzE5NzlMNS4zMTk1NSA0LjgwMDA1TDcuOTk5OCA3LjQ4MDNMMTAuNjgwMSA0LjgwMDA1TDExLjE5OTggNS4zMTk3OUw4LjUxOTU1IDguMDAwMDVMMTEuMTk5OCAxMC42ODAzTDEwLjY4MDEgMTEuMkw3Ljk5OTggOC41MTk3OUw1LjMxOTU1IDExLjJMNC43OTk4IDEwLjY4MDNMNy40ODAwNiA4LjAwMDA1WiIgZmlsbD0iIzZFNzA3NiIvPgo8L3N2Zz4K";